// @ts-nocheck
const Authentication = {
  AUTH_METADATA_PAGE: 'AUTH_META_PAGE',
};

const ACCOUNTS = {
  ACCOUNT: 'ACCOUNT',
  ACCOUNT_TRANSACTION: 'ACCOUNT_TRANSACTION',
  ACCOUNTS: 'ACCOUNTS',
  ACCOUNTS_TYPES: 'ACCOUNTS_TYPES',
};

const ATTACHMENTS = 'ATTACHMENTS';

const FINANCIAL_REPORTS = {
  FINANCIAL_REPORT: 'FINANCIAL-REPORT',
  BALANCE_SHEET: 'BALANCE-SHEET',
  TRIAL_BALANCE_SHEET: 'TRIAL-BALANCE-SHEET',
  PROFIT_LOSS_SHEET: 'PROFIT-LOSS-SHEET',
  GENERAL_LEDGER: 'GENERAL-LEDGER',
  JOURNAL: 'JOURNAL',
  AR_AGING_SUMMARY: 'AR-AGING-SUMMARY',
  AP_AGING_SUMMARY: 'AP-AGING-SUMMARY',
  VENDORS_TRANSACTIONS: 'VENDORS_TRANSACTIONS',
  CUSTOMERS_TRANSACTIONS: 'CUSTOMERS_TRANSACTIONS',
  VENDORS_BALANCE_SUMMARY: 'VENDORS_BALANCE_SUMMARY',
  CUSTOMERS_BALANCE_SUMMARY: 'CUSTOMERS_BALANCE_SUMMARY',
  SALES_BY_ITEMS: 'SALES_BY_ITEMS',
  PURCHASES_BY_ITEMS: 'PURCHASES_BY_ITEMS',
  INVENTORY_VALUATION: 'INVENTORY_VALUATION',
  CASH_FLOW_STATEMENT: 'CASH_FLOW_STATEMENT',
  INVENTORY_ITEM_DETAILS: 'INVENTORY_ITEM_DETAILS',
  TRANSACTIONS_BY_REFERENCE: 'TRANSACTIONS_BY_REFERENCE',
  REALIZED_GAIN_OR_LOSS: 'REALIZED_GAIN_OR_LOSS',
  UNREALIZED_GAIN_OR_LOSS: 'UNREALIZED_GAIN_OR_LOSS',
  PROJECT_PROFITABILITY_SUMMARY: 'PROJECT_PROFITABILITY_SUMMARY',
  SALES_TAX_LIABILITY_SUMMARY: 'SALES_TAX_LIABILITY_SUMMARY',
};

const BILLS = {
  BILLS: 'BILLS',
  BILL: 'BILL',
  BILLS_DUE: 'BILLS_DUE',
  BILLS_PAYMENT_TRANSACTIONS: 'BILLS_PAYMENT_TRANSACTIONS',
  PURCHASE_BILLS: 'PURCHASE_BILLS'
};

const PURCHASE_ORDERS = {
  PURCHASE_ORDERS: 'PURCHASE_ORDERS',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
};

const VENDORS = {
  VENDORS: 'VENDORS',
  VENDOR: 'VENDOR',
};

const CUSTOMERS = {
  CUSTOMERS: 'CUSTOMERS',
  CUSTOMER: 'CUSTOMER',
};

const CUSTOMER_DEPOSITS = {
  CUSTOMER_DEPOSITS: 'CUSTOMER_DEPOSITS',
  CUSTOMER_DEPOSIT: 'CUSTOMER_DEPOSIT',
  RECONCILE_CUSTOMER_DEPOSITS: 'RECONCILE_CUSTOMER_DEPOSITS',
  RECONCILE_CUSTOMER_DEPOSITS_APPLIED_INVOICES: 'RECONCILE_CUSTOMER_DEPOSITS_APPLIED_INVOICES',
}

const ITEMS = {
  ITEMS: 'ITEMS',
  ITEM: 'ITEM',
  ITEMS_CATEGORIES: 'ITEMS_CATEGORIES',
  ITEM_ASSOCIATED_WITH_INVOICES: 'ITEM_ASSOCIATED_WITH_INVOICES',
  ITEM_ASSOCIATED_WITH_ESTIMATES: 'ITEM_ASSOCIATED_WITH_ESTIMATES',
  ITEM_ASSOCIATED_WITH_RECEIPTS: 'ITEM_ASSOCIATED_WITH_RECEIPTS',
  ITEMS_ASSOCIATED_WITH_BILLS: 'ITEMS_ASSOCIATED_WITH_BILLS',
  ITEM_WAREHOUSES_LOCATION: 'ITEM_WAREHOUSES_LOCATION',
  ITEM_INVENTORY_COST: 'ITEM_INVENTORY_COST',
  ITEM_CODE_EXISTS: 'ITEM_CODE_EXISTS',
  ITEM_SKU_LOOKUP: 'ITEM_SKU_LOOKUP',
  ITEM_SKUS: 'ITEM_SKUS',
  ITEM_INVENTORY_HISTORY: 'ITEM_INVENTORY_HISTORY',
  ITEM_INVENTORY_RECORDS: 'ITEM_INVENTORY_RECORDS',
  ITEM_INVENTORY_ORDERS: 'ITEM_INVENTORY_ORDERS',
};

const SALE_ESTIMATES = {
  SALE_ESTIMATES: 'SALE_ESTIMATES',
  SALE_ESTIMATE: 'SALE_ESTIMATE',
  SALE_ESTIMATE_SMS_DETAIL: 'SALE_ESTIMATE_SMS_DETAIL',
  NOTIFY_SALE_ESTIMATE_BY_SMS: 'NOTIFY_SALE_ESTIMATE_BY_SMS',
  SALE_ESTIMATE_MAIL_OPTIONS: 'SALE_ESTIMATE_MAIL_OPTIONS',
  SALE_ESTIMATES_CHART_DATA: 'SALE_ESTIMATES_CHART_DATA',
};

const SALE_PRESENTATIONS = {
  SALE_PRESENTATIONS: 'SALE_PRESENTATIONS',
  SALE_PRESENTATION: 'SALE_PRESENTATION',
  SALE_PRESENTATION_SMS_DETAIL: 'SALE_PRESENTATION_SMS_DETAIL',
  NOTIFY_SALE_PRESENTATION_BY_SMS: 'NOTIFY_SALE_PRESENTATION_BY_SMS',
  SALE_PRESENTATION_MAIL_OPTIONS: 'SALE_PRESENTATION_MAIL_OPTIONS',
  SALE_PRESENTATIONS_CHART_DATA: 'SALE_PRESENTATIONS_CHART_DATA',
};

const SALE_RECEIPTS = {
  SALE_RECEIPTS: 'SALE_RECEIPTS',
  SALE_RECEIPT: 'SALE_RECEIPT',
  SALE_RECEIPT_SMS_DETAIL: 'SALE_RECEIPT_SMS_DETAIL',
  NOTIFY_SALE_RECEIPT_BY_SMS: 'NOTIFY_SALE_RECEIPT_BY_SMS',
  SALE_RECEIPT_MAIL_OPTIONS: 'SALE_RECEIPT_MAIL_OPTIONS',
  SALE_RECEIPT_CHART_DATA: 'SALE_RECEIPT_CHART_DATA'
};

const INVENTORY_ADJUSTMENTS = {
  INVENTORY_ADJUSTMENTS: 'INVENTORY_ADJUSTMENTS',
  INVENTORY_ADJUSTMENT: 'INVENTORY_ADJUSTMENT',
};

const CURRENCIES = {
  CURRENCIES: 'CURRENCIES',
};

// const SALESPEOPLE = {
//   SALESPEOPLE: 'SALESPEOPLE',
// };

const PAYMENT_MADES = {
  PAYMENT_MADES: 'PAYMENT_MADES',
  PAYMENT_MADE: 'PAYMENT_MADE',
  PAYMENT_MADE_NEW_ENTRIES: 'PAYMENT_MADE_NEW_ENTRIES',
  PAYMENT_MADE_EDIT_PAGE: 'PAYMENT_MADE_EDIT_PAGE',
  PAYMENT_MADE_CHART_DATA: 'PAYMENT_MADE_CHART_DATA'
};

const PAYMENT_RECEIVES = {
  PAYMENT_RECEIVES: 'PAYMENT_RECEIVES',
  PAYMENT_RECEIVE: 'PAYMENT_RECEIVE',
  PAYMENT_RECEIVE_NEW_ENTRIES: 'PAYMENT_RECEIVE_NEW_ENTRIES',
  PAYMENT_RECEIVE_EDIT_PAGE: 'PAYMENT_RECEIVE_EDIT_PAGE',
  PAYMENT_RECEIVE_SMS_DETAIL: 'PAYMENT_RECEIVE_SMS_DETAIL',
  NOTIFY_PAYMENT_RECEIVE_BY_SMS: 'NOTIFY_PAYMENT_RECEIVE_BY_SMS',
  PAYMENT_RECEIVE_MAIL_OPTIONS: 'PAYMENT_RECEIVE_MAIL_OPTIONS',
  PAYMENT_RECEIVE_CHART_DATA: 'PAYMENT_RECEIVE_CHART_DATA',
};

const SALE_INVOICES = {
  SALE_INVOICES: 'SALE_INVOICES',
  SALE_INVOICE: 'SALE_INVOICE',
  SALE_INVOICES_DUE: 'SALE_INVOICES_DUE',
  SALE_INVOICE_SMS_DETAIL: 'SALE_INVOICE_SMS_DETAIL',
  NOTIFY_SALE_INVOICE_BY_SMS: 'NOTIFY_SALE_INVOICE_BY_SMS',
  BAD_DEBT: 'BAD_DEBT',
  CANCEL_BAD_DEBT: 'CANCEL_BAD_DEBT',
  SALE_INVOICE_PAYMENT_TRANSACTIONS: 'SALE_INVOICE_PAYMENT_TRANSACTIONS',
  SALE_INVOICE_DEFAULT_OPTIONS: 'SALE_INVOICE_DEFAULT_OPTIONS',
  SALE_INVOICE_COMMISSION: 'SALE_INVOICE_COMMISSION', 
  CATEGORY_SALES: 'CATEGORY_SALES'
};

const SALES_ORDER = {
  SALES_ORDERS: 'SALES_ORDERS',
  SALES_ORDER: 'SALES_ORDER',
  SALES_ORDER_NUMBER: 'SALES_ORDER_NUMBER',
  SALES_ORDER_SMS_DETAIL: 'SALES_ORDER_SMS_DETAIL',
  NOTIFY_SALES_ORDER_BY_SMS: 'NOTIFY_SALES_ORDER_BY_SMS',
  SALES_ORDER_MAIL_OPTIONS: 'SALES_ORDER_MAIL_OPTIONS',
  SALES_ORDERS_CHART_DATA: 'SALES_ORDERS_CHART_DATA',
  SALES_ORDER_DEFAULT_OPTIONS: 'SALES_ORDER_DEFAULT_OPTIONS',
  SALES_ORDER_PAYMENT_TRANSACTIONS: 'SALES_ORDER_PAYMENT_TRANSACTIONS',
  SALES_ORDER_BILL_TOTAL: 'SALES_ORDER_BILL_TOTAL',
};

const USERS = {
  USERS: 'USERS',
  USER: 'USER',
};

const ROLES = {
  ROLE: 'ROLE',
  ROLES: 'ROLES',
  ROLES_PERMISSIONS_SCHEMA: 'ROLES_PERMISSIONS_SCHEMA',
};

const CREDIT_NOTES = {
  CREDIT_NOTE: 'CREDIT_NOTE',
  CREDIT_NOTES: 'CREDIT_NOTES',
  REFUND_CREDIT_NOTE: 'REFUND_CREDIT_NOTE',
  REFUND_CREDIT_NOTE_TRANSACTION: 'REFUND_CREDIT_NOTE_TRANSACTION',
  RECONCILE_CREDIT_NOTE: 'RECONCILE_CREDIT_NOTE',
  RECONCILE_CREDIT_NOTES: 'RECONCILE_CREDIT_NOTES',
};

const VENDOR_CREDIT_NOTES = {
  VENDOR_CREDITS: 'VENDOR_CREDITS',
  VENDOR_CREDIT: 'VENDOR_CREDIT',
  REFUND_VENDOR_CREDIT: 'REFUND_VENDOR_CREDIT',
  REFUND_VENDOR_CREDIT_TRANSACTION: 'REFUND_VENDOR_CREDIT_TRANSACTION',
  RECONCILE_VENDOR_CREDIT: 'RECONCILE_VENDOR_CREDIT',
  RECONCILE_VENDOR_CREDITS: 'RECONCILE_VENDOR_CREDITS',
};

const SETTING = {
  SETTING: 'SETTING',
  SETTING_INVOICES: 'SETTING_INVOICES',
  SETTING_SALES_ORDERS: 'SETTING_SALES_ORDERS',
  SETTING_ESTIMATES: 'SETTING_ESTIMATES',
  SETTING_PRESENTATIONS: 'SETTING_PRESENTATIONS',
  SETTING_RECEIPTS: 'SETTING_RECEIPTS',
  SETTING_PAYMENT_RECEIVES: 'SETTING_PAYMENT_RECEIVES',
  SETTING_MANUAL_JOURNALS: 'SETTING_MANUAL_JOURNALS',
  SETTING_ITEMS: 'SETTING_ITEMS',
  SETTING_CASHFLOW: 'SETTING_CASHFLOW',
  SETTING_SMS_NOTIFICATION: 'SETTING_SMS_NOTIFICATION',
  SETTING_SMS_NOTIFICATIONS: 'SETTING_SMS_NOTIFICATIONS',
  SETTING_EDIT_SMS_NOTIFICATION: 'SETTING_EDIT_SMS_NOTIFICATION',
  SETTING_CREDIT_NOTES: 'SETTING_CREDIT_NOTES',
  SETTING_CUSTOMER_DEPOSITS: 'SETTING_CUSTOMER_DEPOSITS',
  SETTING_PURCHASE_ORDERS: 'SETTING_PURCHASE_ORDERS',
  SETTING_VENDOR_CREDITS: 'SETTING_VENDOR_CREDITS',
  SETTING_WAREHOUSE_TRANSFER: 'SETTING_WAREHOUSE_TRANSFERS',
  SETTING_SALESPEOPLE: 'SETTING_SALESPEOPLE',
  SETTING_SALESPERSON: 'SETTING_SALESPERSON',
};

const LOGO_LIBRARY = {
  LOGO_LIBRARY: 'LOGO_LIBRARY',
};

const ORGANIZATIONS = {
  ORGANIZATIONS: 'ORGANIZATIONS',
  ORGANIZATION_CURRENT: 'ORGANIZATION_CURRENT',
};

const SUBSCRIPTIONS = {
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
};

const EXPENSES = {
  EXPENSES: 'EXPENSES',
  EXPENSE: 'EXPENSE',
  EXPENSE_CHART_DATA: 'EXPENSE_CHART_DATA',
};

const MANUAL_JOURNALS = {
  MANUAL_JOURNALS: 'MANUAL_JOURNALS',
  MANUAL_JOURNAL: 'MANUAL_JOURNAL',
  MANUAL_JOURNAL_CHART_DATA: 'MANUAL_JOURNAL_CHART_DATA',
};

const LANDED_COSTS = {
  LANDED_COST: 'LANDED_COST',
  LANDED_COSTS: 'LANDED_COSTS',
  LANDED_COST_TRANSACTION: 'LANDED_COST_TRANSACTION',
};

const CONTACTS = {
  CONTACTS: 'CONTACTS',
  CONTACT: 'CONTACT',
};

const CASH_FLOW_ACCOUNTS = {
  CASH_FLOW_ACCOUNTS: 'CASH_FLOW_ACCOUNTS',
  CASH_FLOW_TRANSACTIONS: 'CASH_FLOW_TRANSACTIONS',
  CASH_FLOW_TRANSACTION: 'CASH_FLOW_TRANSACTION',
  CASHFLOW_ACCOUNT_TRANSACTIONS_INFINITY:
    'CASHFLOW_ACCOUNT_TRANSACTIONS_INFINITY',
  CASHFLOW_ACCOUNT_UNCATEGORIZED_TRANSACTIONS_INFINITY:
    'CASHFLOW_ACCOUNT_UNCATEGORIZED_TRANSACTIONS_INFINITY',
  CASHFLOW_UNCAATEGORIZED_TRANSACTION: 'CASHFLOW_UNCAATEGORIZED_TRANSACTION',
  CASH_FLOW_ACCOUNTS_CHART_DATA: 'CASH_FLOW_ACCOUNTS_CHART_DATA',
};

const TARNSACTIONS_LOCKING = {
  TRANSACTION_LOCKING: 'TRANSACTION_LOCKING',
  TRANSACTIONS_LOCKING: 'TRANSACTIONS_LOCKING',
};

const WAREHOUSES = {
  WAREHOUSE: 'WAREHOUSE',
  WAREHOUSES: 'WAREHOUSES',
};
const WAREHOUSE_TRANSFERS = {
  WAREHOUSE_TRANSFER: 'WAREHOUSE_TRANSFER',
  WAREHOUSE_TRANSFERS: 'WAREHOUSE_TRANSFERS',
};

const BRANCHES = {
  BRANCHES: 'BRANCHES',
  BRANCH: 'BRANCH',
};

const CARRIERS = {
  CARRIERS: 'CARRIERS',
  CARRIER: 'CARRIER',
};

const INVENTORY_RECEIVING = {
  INVENTORY_RECEIVING_ORDERS: 'INVENTORY_RECEIVING_ORDERS',
  INVENTORY_RECEIVING_LINE_ITEMS: 'INVENTORY_RECEIVING_LINE_ITEMS',
};

const INVENTORY_SHIPPING = {
  INVENTORY_SHIPPING_ORDERS: 'INVENTORY_SHIPPING_ORDERS',
  INVENTORY_SHIPPING_SPLIT_SHIPMENTS: 'INVENTORY_SHIPPING_SPLIT_SHIPMENTS',
};

const SHIPPING_ACCOUNTS = {
  SHIPPING_ACCOUNTS: 'SHIPPING_ACCOUNTS',
  SHIPPING_ACCOUNT: 'SHIPPING_ACCOUNT',
};

const SHIP_METHODS = {
  SHIP_METHODS: 'SHIP_METHODS',
  SHIP_METHOD: 'SHIP_METHOD',
};

const PO_TRACKING = {
  PO_TRACKING_LIST: 'PO_TRACKING_LIST',
  PO_TRACKING_ORDER: 'PO_TRACKING_ORDER',
};

const DASHBOARD = {
  DASHBOARD_META: 'DASHBOARD_META',
};

const ORGANIZATION = {
  ORGANIZATION_MUTATE_BASE_CURRENCY_ABILITIES:
    'ORGANIZATION_MUTATE_BASE_CURRENCY_ABILITIES',
};

const E_SALE_INVOIVE = {
  E_SALE_INVOICE: 'E_SALE_INVOICE',
}

const FILTERED_INVOICES = {
  FILTERED_INVOICES: 'FILTERED_INVOICES',
}

export const TAX_RATES = {
  TAX_RATES: 'TAX_RATES',
};

export const EXCHANGE_RATE = {
  EXCHANGE_RATE: 'EXCHANGE_RATE',
};

export default {
  ...Authentication,
  ...ACCOUNTS,
  ...BILLS,
  ...PURCHASE_ORDERS,
  ...SALES_ORDER,
  ...VENDORS,
  ...CUSTOMERS,
  ...CUSTOMER_DEPOSITS,
  ...FINANCIAL_REPORTS,
  ...ITEMS,
  ...SALE_ESTIMATES,
  ...SALE_PRESENTATIONS,
  ...INVENTORY_ADJUSTMENTS,
  ...CURRENCIES,
  ...SALE_RECEIPTS,
  ...PAYMENT_MADES,
  ...PAYMENT_RECEIVES,
  ...SALE_INVOICES,
  ...E_SALE_INVOIVE,
  ...FILTERED_INVOICES,
  ...USERS,
  ...SETTING,
  ...ORGANIZATIONS,
  ...SUBSCRIPTIONS,
  ...EXPENSES,
  ...MANUAL_JOURNALS,
  ...LANDED_COSTS,
  ...CONTACTS,
  ...CASH_FLOW_ACCOUNTS,
  ...ROLES,
  ...CREDIT_NOTES,
  ...VENDOR_CREDIT_NOTES,
  ...TARNSACTIONS_LOCKING,
  ...WAREHOUSES,
  ...WAREHOUSE_TRANSFERS,
  ...BRANCHES,
  ...CARRIERS,
  ...INVENTORY_RECEIVING,
  ...INVENTORY_SHIPPING,
  ...SHIPPING_ACCOUNTS,
  ...SHIP_METHODS,
  ...PO_TRACKING,
  ...DASHBOARD,
  ...ORGANIZATION,
  ...TAX_RATES,
  ...EXCHANGE_RATE,
  ...LOGO_LIBRARY,
  ATTACHMENTS,
  COMMISSIONS_LIST: 'COMMISSIONS_LIST',
   COMMISSION_PAYMENT: 'COMMISSION_PAYMENT',
};
